<app-segov-sigepo-portal-body>

  <div>
    <app-edicao-do-dia/>
  </div>
  <div>
    <div class="space-secoes-inicio">
      <h2 class="titulo-card">
       Um <span style="color: var(--tom-1-jornal)">Diário</span> feito para você!</h2>
      <div class="row ">
        @for(info of DiarioFeitoParaVoce; track $index){
        <div class="col-12 col-lg-4 mt-3 mt-lg-0" style="display: flex; justify-content: center;">
          <lib-segov-sigepo-card-with-image
            [style]="'width: 100%'"
            [Card]="info" />
        </div>
        }
      </div>
    </div>

    <div class="space-secoes-inicio">
      <h2 class="titulo-card">
         <span style="color: var(--tom-2-informativo)">Serviços</span>
        disponíveis no <span style="color: var(--tom-2-jornal)">Jornal Minas Gerais</span></h2>
      <div class="servicos-container row" style="margin: 0; justify-content: center; ">
        <div class="col-lg-3 col-8" style="padding-left: 2rem;">
          <span class="servicos-descricao">Conheça nossos serviços e conte com a gente para garantir transparência e
            praticidade em suas publicações!</span>
        </div>
        <div class="col-12 col-lg-7">
          <lib-segov-sigepo-card-carousel
          [numeroItensPorPagina]="numeroItensPorPagina"
          [items]="Cards" />
        </div>
      </div>
    </div>

    <div class="space-secao-comunicado">
      <app-card-comunicados />
    </div>

    <div class="space-secoes-inicio">
      <h2 class="titulo-card">
       Mais de 130 anos de <span style="color: var(--tom-1-jornal)">informação oficial!</span></h2>
      <div class="row">
        @for(info of InformacoesOficiais; track $index){
        <div class="col-12 col-lg-4 mt-3 mt-lg-0" style="display: flex; justify-content: center;">
          <lib-segov-sigepo-card-with-image
            [Card]="info" />
        </div>
        }
      </div>
    </div>
  </div>
</app-segov-sigepo-portal-body>

<lib-segov-sigepo-modal
    [showModal]="exibirNotificacao"
    [maxWidthExterno]="'720px'"
    [hasHeader]="false"
    [showCloseIcon]="true"
    (closedModal)="exibirNotificacao = false">
    <article body>
      <h4 class="mb-4">Caro usuário(a),</h4>
      <p>Informamos que eventualmente poderá haver alguma instabilidade em nossos serviços que possa interferir na disponibilização do Jornal Minas Gerais no horário habitual, mas nossas equipes já estão atuando para normalizar essa situação. Contamos com a compreensão de todos pelos eventuais transtornos e nos colocamos à disposição por meio de nossos canais de atendimento.</p>
    </article>
</lib-segov-sigepo-modal>
